import { render, staticRenderFns } from "./classesAttendance1.vue?vue&type=template&id=61c62dd8&scoped=true&"
import script from "./classesAttendance1.vue?vue&type=script&lang=js&"
export * from "./classesAttendance1.vue?vue&type=script&lang=js&"
import style0 from "./classesAttendance1.vue?vue&type=style&index=0&id=61c62dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c62dd8",
  null
  
)

export default component.exports